module.exports = __webpack_public_path__ + "static/media/logo.e87fbb4f.webp";